export default "__VITE_ASSET__Caw32MuZ__"